export class Form {
    ID:number;
    NAME:string;
    LINK:string;
    PARENT_ID:number;
    ICON:string;
    CLIENT_ID:number;
}
